import React from 'react';
import { DeprecatedButton as Button } from '@modernhealth/vital-components';
import { useHistory } from 'react-router';
import { useAnalytics } from '@modernhealth/web-analytics';

import { useRoute } from '../contexts/RouteContext';

export const BackButton: React.FC = () => {
  const history = useHistory();
  const route = useRoute();
  const analytics = useAnalytics();

  return (
    <Button
      css={{
        paddingLeft: 0,
        paddingRight: 0,
      }}
      onClick={() => {
        if (route.from === '') {
          analytics.trackClick('Back', {
            pagePath: route.to,
            destinationPath: '/',
          });

          history.push('/');
          return;
        }

        analytics.trackClick('Back', {
          pagePath: route.to,
          destinationPath: route.from,
        });

        history.goBack();
      }}
      variant="flat"
      size="large"
      startIcon="arrow-left"
      title="Back"
    />
  );
};
